import {
  BUTTON_EVENT_SEPARATOR,
  EVENTS_BUTTONS,
  STATUS,
  IFeedbackCount,
  FEEDBACK,
} from "./constants";
import { showAdviserButtonForTwoBadFeedbacks } from "./feedback-intentions";
import { openChat } from "../five9";
import { getAivo, getAivoChat } from "./utils";
import { showAdviserButtonForTwoConsecutiveUnansweredQuestions } from "./interactions";
import { OPEN_FIVE9_CHAT_EVENT } from "@siigo/five9/chat";
import { setMinimizeButtonStylesAndEvents } from "./styles";
import { hide, show } from "./launcher";

export function subscribeEventButtons(configurations: any): void {
  getAivo()?.subscribe.onSelectedButton(function (value: string) {
    /* Value llega como un string con dos posibles estructuras
     * la primera consta directamente del mensaje que enviara el botón
     * o una lista de valores separados por "|||" la cual se compone de la
     * siguiente forma: aivo-studio|||message_contact_adviser|||ApiClientCall1657658433
     * donde la opción de la mitad es el nombre del flow que se disparara
     */
    const valueSplit: string[] = value.split(BUTTON_EVENT_SEPARATOR);
    const buttonId: string =
      valueSplit.length > 1 ? valueSplit[1] : valueSplit[0];
    if (!buttonId) return;
    switch (buttonId) {
      case EVENTS_BUTTONS.MESSAGE_CONTACT_ADVISER:
      case EVENTS_BUTTONS.TALK_WITH_ADVISER:
        getAivo().statusEvent = STATUS.CLOSED;
        openChat(configurations.five9);
        getAivoChat().minimize();
        hide();
        break;
      default:
        break;
    }
  });
}

export function subscribeMinimizeChat(): void {
  getAivo()?.subscribe?.onMinimizeWindow(() => {
    //Mostrar el botón de inicio cuando se minimiza el chat
    show();
    setMinimizeButtonStylesAndEvents();
  });
}

export function subscribeOpenChat(): void {
  getAivo().subscribe.onOpenWindow(() => {
    getAivo().statusEvent = STATUS.OPEN;
  });
}

export function subscribeCloseChat(): void {
  getAivo().subscribe.onCloseWindow(() => {
    getAivo().statusEvent = STATUS.CLOSED;
    //Se oculta botón de inicio de acuerdo a las normas de siigo nube
    hide();
  });
}

export function subscribeFeedbackIntention(): void {
  let feedbackCount: IFeedbackCount = {
    good: 0,
    bad: 0,
  };
  getAivo()?.user?.set(FEEDBACK.PROPERTY, feedbackCount);

  getAivo()?.subscribe.onFeedbackIntention(function (value: boolean) {
    showAdviserButtonForTwoBadFeedbacks(value);
  });
}

export function openFive9ChatListener(): void {
  window.addEventListener(OPEN_FIVE9_CHAT_EVENT, () => {
    getAivo()?.statusEvent && getAivo()?.statusEvent != STATUS.CLOSED
      ? getAivo()?.chat.close()
      : hide();
  });
}

export function subscribeInteraction(): void {
  getAivo()?.subscribe.onInteraction(function (type: string, question: string) {
    showAdviserButtonForTwoConsecutiveUnansweredQuestions(type, question);
  });
}
